/**
 * 商品主キー
 */
export class ProductPrimaryKey {
    /** 都道府県コード */
    prefectureCode = ""
    /** 顧客コード (999999) */
    code = ""
    /** 検査項目コード */
    inspectionCode = ""
}

/**
 * 商品
 */
export class Product {
    pk = new ProductPrimaryKey()
    /** 検査項目名 */
    inspectionName = ""
    /** 検査項目名（略称） */
    inspectionShortName = ""
    /* 検査分類コード */
    classificationCode = ""
    /** その他項目フラグ 0: 検査項目 1: その他の項目 ※報告書が不要かどうかの判断 */
    otherItem = false
    /** 検査日数 */
    days = 0
    /** ユーザ単価 */
    unitPrice = 0
    /** 標準単価 */
    standardPrice = 0
    /** 単価 */
    price: number | string | null = null

    /* 検査分類名 */
    classificationName = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Product>) {
        Object.assign(this, init)
    }
}
